import { render, staticRenderFns } from "./group-form.component.vue?vue&type=template&id=d700e204"
import script from "./group-form.component.vue?vue&type=script&lang=js"
export * from "./group-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports